module.exports = __webpack_public_path__ + "img/no-events-img.d040f762.png";